import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Company } from "@core/models/company";
import { MixpanelService } from "@core/services/mixpanel.service";
import { MenuItem } from "primeng/api";
import { takeUntil } from "rxjs";
import { DestroyObservable } from "src/app/rxjs/DestroyObservable";
import { ChromeExtensionService } from "src/app/services/chrome-extension/chrome-extension.service";
import { CompaniesService } from "src/app/services/companies/companies.service";

enum ExtensionTabs {
  PromptManager = "Prompt Manager",
  TechAnalyst = "Tech Analyst",
}

@Component({
  selector: "bpc-extension-v2",
  templateUrl: "./extension-v2.component.html",
  styleUrl: "./extension-v2.component.scss",
})
export class ExtensionV2Component {
  ExtensionTabs = ExtensionTabs;
  items: MenuItem[] | undefined;
  activeItem: MenuItem | undefined;
  companyDetails!: Company;
  chatGpt: boolean = false;
  domain!: string;
  constructor(
    private chromeExtensionService: ChromeExtensionService, 
    private mixpanelService: MixpanelService,
    private route: ActivatedRoute,
  
  ) {}

  ngOnInit() {
    this.chromeExtensionService.isExtension.next(true);
    this.chromeExtensionService.loading = true;
    this.mixpanelService.trackEvent('Extension_Viewed');

    this.items = [
      { label: ExtensionTabs.PromptManager, icon: "pi pi-book" },
      { label: ExtensionTabs.TechAnalyst, icon: "pi pi-comments" },
    ];
    this.activeItem = this.items[0];

    this.domain = this.route.snapshot.queryParams['domain'];
    if (this.domain.includes('chatgpt.com')){
      this.chatGpt = true;
    }
  }

  onActiveItemChange(event: MenuItem) {
    this.activeItem = event;
  }
}
